import { useState, useEffect } from "react";
import Joi from "joi-browser";
import { message } from "antd";

import Form from "V2.0/components/Form";
import { showErrorToast } from "V2.0/utils";
import Twilio from "V2.0/images/twilio.svg";

function TwilioComponent({ projectId, twilioSettings, updateTwilioSettings, isViewOnly }) {
  const [formFieldforTwilio, setFormFieldForTwilio] = useState({
    twilioAccountSID: "",
    twilioAuthToken: "",
  });

  const [errorMessage] = useState({});

  useEffect(() => {
    if (twilioSettings) {
      setFormFieldForTwilio({
        twilioAccountSID: twilioSettings?.twilioAccountSID,
        twilioAuthToken: twilioSettings?.twilioAuthToken,
      });
    }
  }, [twilioSettings]);

  const [loading, setLoading] = useState(false);

  const templateTwilio = [
    {
      name: "twilioAccountSID",
      label: "Account SID",
      type: "text",
      style: "",
      disabled: isViewOnly
    },
    {
      name: "twilioAuthToken",
      label: "Auth Token",
      type: "password",
      style: "",
      disabled: isViewOnly
    },
  ];

  const buttonInfoTwilio = !isViewOnly ? {
    label: "Connect Twilio",
    style: "entire-width",
  } : {};

  const schemaTwilio = {
    twilioAccountSID: Joi.string().max(5000).required().label("Account SID"),
    twilioAuthToken: Joi.string().max(5000).required().label("Auth SID"),
  };

  const handleTwilioConnection = async (data) => {
    let telephonySettings = {
      telephonySettings: {
        telephonyProvider: "twilio",
        twilioSettings: {
          twilioAccountSID: data.twilioAccountSID,
          twilioAuthToken: data.twilioAuthToken,
        },
      },
    };

    const lifecycleCbs = {
      init: () => {
        message.loading("Connecting Twilio");
      },
      success: () => {
        message.destroy();
        setLoading(false);
        message.success("Twilio Connected");
      },
      error: (e) => {
        message.destroy();
        setLoading(false);
        showErrorToast(e, "Failed to connect Twilio");
      },
    };

    updateTwilioSettings(telephonySettings, projectId, lifecycleCbs);
  };

  return (
    <div>
      <div class="flex flex-col items-center">
        <div className="w-full max-w-md p-8 border rounded-lg">
          <div className="flex gap-x-2 mb-4">
            <img
              src={Twilio}
              width={24}
            />
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Connect Twilio account
            </h3>
          </div>

          <div>
            <Form
              key={JSON.stringify(formFieldforTwilio)}
              errorMessage={errorMessage}
              inputField={formFieldforTwilio}
              template={templateTwilio}
              schema={schemaTwilio}
              buttonInfo={buttonInfoTwilio}
              onSubmit={handleTwilioConnection}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TwilioComponent;
